module.exports = __webpack_public_path__ + "static/media/skyline.6561975b.png";